export default __webpack_public_path__ + "static/media/icon-calendar.95c548f1.svg";